import React from "react";
import {
	Box,
	Chip,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
} from "@mui/material";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import moment from "moment";
import type { IGiftItem } from "./type";

interface Props {
	gift: IGiftItem;
	serial: number;
	onEdit: (gift: IGiftItem) => void;
	onDelete: (gift: IGiftItem) => void;
}

const GiftTableRow: React.FC<Props> = ({
	gift,
	serial,
	onEdit,
	onDelete,
}) => {
	const isCollected =
		gift.gift_collected === 1 ||
		gift.gift_collected === true ||
		String(gift.gift_collected) === "1";

	return (
		<TableRow hover>
			{/* SL. */}
			<TableCell sx={{ width: 60, fontWeight: 600 }}>{serial}</TableCell>

			{/* Visitor Pass No */}
			<TableCell>
				<Typography variant="body2" fontWeight={700} color="primary.main">
					{gift.visitor_no || "-"}
				</Typography>
			</TableCell>

			{/* Visitor Name */}
			<TableCell>
				<Typography variant="body2" fontWeight={600}>
					{gift.visitor_name || "-"}
				</Typography>
			</TableCell>

			{/* Phone */}
			<TableCell>
				<Typography variant="body2">{gift.visitor_phone || "-"}</Typography>
			</TableCell>

			{/* Email */}
			<TableCell>
				<Typography variant="body2">{gift.visitor_email || "-"}</Typography>
			</TableCell>

			{/* Status */}
			<TableCell>
				<Chip
					size="small"
					label={isCollected ? "Collected" : "Not Collected"}
					color={isCollected ? "success" : "warning"}
					sx={{
						fontWeight: 700,
						fontSize: "0.75rem",
					}}
				/>
			</TableCell>

			{/* Date */}
			<TableCell>
				<Typography variant="body2">
					{gift.created_at ? moment(gift.created_at).format("ll LT") : "-"}
				</Typography>
			</TableCell>

			{/* Actions */}
			<TableCell align="right">
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5 }}>
					{/* Edit / Update */}
					<Tooltip title="Update Status" arrow>
						<IconButton
							size="small"
							color="info"
							onClick={() => onEdit(gift)}
						>
							<EditTwoToneIcon fontSize="small" />
						</IconButton>
					</Tooltip>

					{/* Delete */}
					<Tooltip title="Delete" arrow>
						<IconButton
							size="small"
							color="error"
							onClick={() => onDelete(gift)}
						>
							<DeleteTwoToneIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Box>
			</TableCell>
		</TableRow>
	);
};

export default GiftTableRow;
